import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import PropTypes from 'prop-types';
import React from 'react';

const CustomPagination = ({ serverPage, totalPages, paginationData, rowsPerPage, changePage }) => {
  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: 10 }}>
        <button
          type="button"
          onClick={() => changePage(serverPage - 1)}
          disabled={serverPage === 1}
          style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '1.5rem' }}
        >
          <ChevronLeft fontSize="large" />
        </button>
        <span style={{ margin: '0 10px' }}>
          Page {serverPage} of {totalPages}
        </span>
        <button
          type="button"
          onClick={() => changePage(serverPage + 1)}
          disabled={serverPage >= totalPages}
          style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '1.5rem' }}
        >
          <ChevronRight fontSize="large" />
        </button>
      </div>
      <div style={{ textAlign: 'center', marginTop: 5 }}>
        Showing {(serverPage - 1) * rowsPerPage + 1}-{Math.min(serverPage * rowsPerPage, paginationData?.total)} of{' '}
        {paginationData?.total} records
      </div>
    </>
  );
};

CustomPagination.propTypes = {
  serverPage: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  paginationData: PropTypes.object.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  changePage: PropTypes.func.isRequired
};

export default CustomPagination;
